import { OrderPatient } from './orderPatient';
import { Address } from '@classes/address';
import { BaseClass } from '../base-class';
import { OrderScan } from './orderScan';
import { Tariff } from '@classes/tariff';
import { ScanType } from '@enums/scan-type';

export class OrderStep extends BaseClass {
  address: Address
  otherAddress: string;
  service: string;
  ordererComment: string;
  isPickup: boolean;
  isDelivery: boolean;
  isExtraStep: boolean;
  requestedDate?: Date;

  tariffs?: Tariff[];

  arrivedOn?: Date;
  completedOn?: Date;
  driverComment?: string;
  hasSignature?: boolean;
  signatory?: string;
  scans?: OrderScan[];
  scansGroupedByContainer?: {};
  tagScanned?: string;
  editArrivedOn?: boolean;
  editCompletedOn?: boolean;
  editMode?: boolean;
  patients?: OrderPatient[];
  hasPhoto?: boolean;
  waitingTime?: number;

  constructor()
  constructor(
    address: Address, otherAddress: string, service: string, ordererComment: string, isPickup: boolean, isDelivery: boolean, patients?: OrderPatient[], tariffs?: Tariff[])
  constructor(
    address?: Address, otherAddress?: string, service?: string, ordererComment?: string, isPickup?: boolean, isDelivery?: boolean, patients?: OrderPatient[], tariffs?: Tariff[]) {
    super();

    this.address = address;
    this.otherAddress = otherAddress;
    this.service = service;
    this.ordererComment = ordererComment;
    this.isPickup = isPickup;
    this.isDelivery = isDelivery;
    this.patients = patients;
    this.tariffs = tariffs;
  }

  static fromObject(object: OrderStep): OrderStep {
    return Object.assign(new OrderStep(), {
      ...object,
      address: object.address ? Address.fromObject(object.address) : object.otherAddress
    });
  }

  get display(): string {
    return this.address.name || this.otherAddress;
  }


  public countDeliveryScan(): number {
    return this.countByScanType(ScanType.delivery);
  }

  public countPickupScan(): number {
    return this.countByScanType(ScanType.pickup);
  }

  private countByScanType(scanType: ScanType) {
    return this.scans?.filter(scan => scan.code && scan.type == scanType)?.reduce((acc, scan) => acc + scan.quantity, 0) || 0;
  }
}
